import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Create Project")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_flex_project_form_component = _resolveComponent("flex-project-form-component")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_flex_project_form_component, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, {
            color: _ctx.message.error ? 'danger' : 'success'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message.text), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_ion_button, {
            slot: "end",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}